<template>
  <div class="modal fade" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
    <LoadingBar v-show="isShowLoadingBar" />

    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Domain Name</h4>
        </div>
        <div class="modal-body">
          <form @keyup="resetChecking()">

            <div class="row">
              <label>1. Please enter domain name. We will check if this name valid and free.</label>

              <div class="col-md-12">
                <div :class="{'has-error': form.errors.has('name')}">
                  <span class="help-block"><strong>{{ form.errors.get('name') }}</strong></span>

                  <div>
                    <input type="text"
                           placeholder="example.com"
                           name="name"
                           class="long-input"
                           v-model="form.name"
                           :disabled="form.request">

                    <span v-show="checking" class="status-check"><i class="fa fa-spinner fa-spin"></i></span>
                    <span v-show="checked" class="status-check"><i class="fa fa-check"></i></span>
                    <span v-show="invalid" class="status-check"><i class="fa fa-times"></i></span>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <div class="row" v-show="hasProfileValidationErrors"
               :class="{'has-error': hasProfileValidationErrors}">
            <label>Domain valid but before register you must fill out next fields in your profile:</label>
            <div class="col-md-12">
              <span class="help-block" v-for="(field, key) in errorsAfterCheck">
                <i class="fa fa-exclamation"></i> {{ form.errors.get(key) }}
              </span>
            </div>
          </div>

          <div v-show="checked && !hasProfileValidationErrors" class="payment-row row">
            <label>2. Please select payment system</label>

            <span class="help-block"><strong>{{ paymentError }}</strong></span>

            <div class="col-md-6">
              <div class="payment-block">
                <div class="payment-btn-wrap align-center">
                  <button type="button"
                          class="btn btn--primary"
                          :disabled="form.request"
                          @click="paymentWorldPay()">Worldpay</button>
                </div>

                <div class="payment-img align-center">
                  <img src="/images/payment-worldpay.png" alt="">
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="payment-block">
                <div class="payment-btn-wrap align-center">
                  <button type="button"
                          class="btn btn--primary"
                          :disabled="form.request"
                          @click="paymentPayPal()">Paypal</button>
                </div>

                <div class="payment-img align-center">
                  <img src="/images/payment-paypal.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button v-show="!checked" :disabled="form.request" type="button" class="btn btn--primary" @click="check()">Ok</button>
          <button :disabled="form.request" type="button" class="btn btn-default" @click="close()">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Form from './../../helpers/form';
import helpers from './../../mixins/helpers';
import paymentApi from './../../api/payment';

export default {
  mixins: [helpers],

  props: {
    show: {
      type: Boolean,
    },

    routeCheck: {
      type: String
    },

    routePaymentPayPal: {
      type: String
    },

    routePaymentWorldPay: {
      type: String
    },

    service: {
      type: Object,
    },

    illustrator: {
      type: Object,
    },
  },

  data() {
    return {
      form: new Form({
        name: ''
      }),

      statuses: {
        start: 'start',
        checking: 'checking',
        checked: 'checked',
        invalid: 'invalid',
      },

      paymentError: '',

      isShowLoadingBar: false,

      status: 'start'
    };
  },

  watch: {
    show(isShow) {
      $(this.$el).modal(isShow ? 'show' : 'hide');
    }
  },

  computed: {
    checking() {
      return this.isStatus(this.statuses.checking);
    },

    checked() {
      return this.isStatus(this.statuses.checked);
    },

    invalid() {
      return this.isStatus(this.statuses.invalid);
    },

    errorsAfterCheck() {
      return this.form.errors.errors;
    },

    hasProfileValidationErrors() {
      return !this.form.errors.has('name') && !this.form.errors.has('error') && this.form.errors.any();
    }
  },

  methods: {
    check() {
      this.setStatus(this.statuses.checking);

      this.form.errors.clear();

      this.form.get(this.routeCheck, false)
        .then((response) => {
          if (! response.valid) {
            this.setStatus(this.statuses.invalid);

            this.setError('This domain invalid. Please type other name.');

            return;
          }

          this.setStatus(this.statuses.checked);
        })
        .catch(() => {
          if (this.hasProfileValidationErrors) {
            this.setStatus(this.statuses.checked);
          } else {
            this.setError('This domain invalid. Please type other name.');

            this.setStatus(this.statuses.invalid);
          }
        });
    },

    paymentPayPal() {
      this.payment('paypal');
    },

    paymentWorldPay() {
      this.payment('worldpay');
    },

    payment(type) {
      this.form.errors.clear();

      if (this.form.request) return;

      this.form.setRequest();

      this.showLoadingBar();

      let route = (type === 'paypal' ? this.routePaymentPayPal : this.routePaymentWorldPay);

      paymentApi
        .payment(route, {
          domain: this.form.name,
          service_id: this.service.id,
          illustrator_id: this.illustrator.id,
        })
        .then((response) => {
          if (response.link) {
            location.href = response.link;
          } else {
            this.paymentError = 'We have problems with payment system PayPal. Please contact with administrator.';
          }

          this.form.unsetRequest();

          this.hideLoadingBar();
        })
        .catch(() => {
          this.setError('We have some problems registering domain. Please contact with administrator.');

          this.form.unsetRequest();

          this.hideLoadingBar();
        });
    },

    close() {
      this.$emit('close');
    },

    resetChecking() {
      this.form.errors.clear();

      this.setStatus(this.statuses.start);
    },

    setError(error) {
      this.form.errors.record({name: [error]});
    },

    showLoadingBar() {
      this.isShowLoadingBar = true;
    },

    hideLoadingBar() {
      this.isShowLoadingBar = false;
    },

    setStatus(status) {
      this.status = status;
    },

    isStatus(status) {
      return this.status === status;
    },
  }
};
</script>

<style lang="scss" scoped>
  .btn:hover, .btn:focus, .btn.focus {
    color: #ffffff;
    text-decoration: none;
  }

  .status-check {
    left: 35px;
    position: relative;
    float: right;
    bottom: 65px;

    i {
      font-size: 1.5em;
    }
  }
</style>
